(function () {
    if ($('#billing-and-reconciliation-page').length) {
        $('.handle-upload-input-trigger').on('click', function () {
            $(this).parent().children('.handle-upload-input').trigger('click');
        });

        $('.handle-upload-input-trigger').on('keydown', function (e) {
            e.preventDefault();
        });

        $('.handle-upload-input').on('change', function (e) {
            $(this)
                .parent()
                .children('.handle-upload-input-trigger')
                .val(e.target.files.length === 1 ? e.target.files[0].name : `${e.target.files.length} files selected`);
            $(this).parent().children('.handle-upload-input-trigger').trigger('blur');
        });
    }

    if ($('#select-multiple-options-with-group').length) {
        if ($('.group-select-multiple').length) {
            var resultsValue = $('.group-select-multiple').data('results');
            var selector = '#' + resultsValue + ' .select2-results__group';

            $(document).on('click', selector, function (e) {
                let selectedItems = [];
                let selectedItemsOptions = $(this).parent().children('ul').children('li');
                let selectedItemsIds = [];
                let uniqueSelectedItems = [];

                // Keep previous selected values
                if ($('.group-select-multiple').val()) {
                    selectedItems = selectedItems.concat($('.group-select-multiple').val());
                }

                // Save every option within the group and mark them as selected
                selectedItemsOptions.each((index, element) => {
                    selectedItemsIds.push(element.id.split('-')[element.id.split('-').length - 1]);
                    $(element).attr('aria-selected', true);
                });

                // Unselect everything if the were selected
                if (selectedItemsIds.every(val => selectedItems.includes(val))) {
                    uniqueSelectedItems = selectedItems.filter(function (element, index, self) {
                        return index === self.indexOf(element);
                    });

                    selectedItemsOptions.each((index, element) => {
                        $(element).attr('aria-selected', false);

                        uniqueSelectedItems = uniqueSelectedItems.filter(
                            location => location != element.id.split('-')[element.id.split('-').length - 1]
                        );
                    });
                } else {
                    // select not repeated locations
                    selectedItems = selectedItems.concat(selectedItemsIds);

                    uniqueSelectedItems = selectedItems.filter(function (element, index, self) {
                        return index === self.indexOf(element);
                    });
                }

                $('.group-select-multiple').val(uniqueSelectedItems);
                $('.group-select-multiple').trigger('change');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/billing-and-reconciliation.js